import { FormId } from './formId';

export type ModalId = SimpleModalId | FormId;

export enum SimpleModalId {
  AegisubNames = 'aegisubNames',
  AegisubProcessedData = 'aegisubProcessedData',
  AegisubAudioToVideoTranslator = 'aegisubAudioToVideoTranslator',
  AddParticipant = 'addParticipantModal',
  EditParticipant = 'editParticipantModal',
  DeleteParticipant = 'deleteParticipantModal',
  ClientsUserSuccessMessage = 'clientsUserSuccessMessage',
  ParticipantReview = 'participantReview',
  MoParticipantsSync = 'moParticipantsSync',
  ParticipantBlacklistConfirmation = 'ParticipantBlacklistConfirmation',
  EventActionLogDetails = 'eventActionLogDetails',
  PreviewSlide = 'PreviewSlide',
  DeleteUser = 'deleteUserModal',
  DeleteVGParticipantAsset = 'deleteVGParticipantAsset',
  AddPortalModal = 'addPortalModal',
  EditPortalModal = 'editPortalModal',
  SocialMediaModal = 'socialMediaModal',
  ArchiveEvent = 'archiveEvent',
  ArchiveClient = 'archiveClient',
  LogDetails = 'logDetails',
  CancelEvent = 'cancelEvent',
  ActionLog = 'actionLog',
  PortalsUploadList = 'portalsUploadList',
  DeletePortalModal = 'deletePortalModal',
  ClearPortalCacheModal = 'clearPortalCacheModal',
  AddTemplateModal = 'addTemplateModal',
  CreateJobModal = 'createJobModal',
  UpdateTemplateModal = 'updateTemplateModal',
  CreateAfterEffectsParticipantModal = 'createAfterEffectsParticipantModal',
  EditAfterEffectsParticipantModal = 'editAfterEffectsParticipantModal',
  CreateAfterEffectsChapterModal = 'createAfterEffectsChapterModal',
  EditAfterEffectsChapterModal = 'editAfterEffectsChapterModal',
  AddMusicModal = 'addMusicModal',
  DownloadSummary = 'downloadSummaryModal',
  UnlockTemplate = 'unlockTemplate',
  UnlockClip = 'unlockClip',
  ResetRender = 'resetRender',
}
